import { useState } from 'react';
import useWidth from '../../../../../../components/Hooks/useWidth';
import OrderProductsViewButtonView from './OrderProductsViewButtonView';
import useOrderProductsView from './hooks/useOrderProductsView';

const OrderProductsViewButton = () => {
  const { mediumDownWidth } = useWidth();
  const [hasOpenedPanel, setHasOpenedPanel] = useState(false);
  const viewConfig = useOrderProductsView({ areOptionsEnabled: hasOpenedPanel });

  return (
    <OrderProductsViewButtonView
      isCollapsed={mediumDownWidth}
      {...viewConfig}
      onOpenPanel={() => setHasOpenedPanel(true)}
    />
  );
};

export default OrderProductsViewButton;
